import React, {useCallback, useState} from 'react';
import {useAuth} from "../../../providers/AuthProvider";
import {Card, Checkbox, Space, Tag, Typography} from "antd";
import User from "../../../models/User";

const { Title, Text, Paragraph } = Typography;

const LinkTypes = TB.map(laravel.talent_profile_link_types, (link, type) => ({...link, type}));

const ResumeImportSelection = (props) => {
    const {auth, talentUpdate, update: updateAuthProps, isUpdating} = useAuth();

    // const [resumeImportData, setResumeImportData] = useState(() => auth.isApplicationApproved() ?
    //     auth.availableProfileItemsForResumeImport() :
    //     auth.availableApplicationItemsForResumeImport()
    // );
    const [resumeImportData, setResumeImportData] = useState(() => auth.availableItemsForResumeImport());
    const resetSelected = (data) => {
        const infoFields = [
            'phone',
            'email',
            'linkedin_profile_url',
            'years_of_experience',
            'bio',
            'project_interest'
        ]
        const profileItemFields = [
            'jobs',
            'skills',
            'industries_worked',
            'schools',
            'certifications',
            'awards',
            'services',
            'disciplines',
            'profile_links',
        ]
        let existing = User.getResumeImportsForUser(auth.id) || {};

        let selected = {};
        TB.map(infoFields, field => {
            selected[field] = existing?.[field];
        })
        TB.map(profileItemFields, field => {
            if (resumeImportData?.[field]?.length > 0) {
                selected[field] = {};
                TB.map(resumeImportData[field], (item, index) => {
                    selected[field][index] = TB.find(existing?.[field] || [], ['id', item.id]);
                })
            }
        })
        return selected
    }
    const [selectedFields, setSelectedFields] = useState(() => resetSelected(resumeImportData));

    const persistSelection = async () => {
        const fields = {
            'linkedin_profile_url':'linkedin_profile_url',
            'years_of_experience':'years_of_experience',
            'bio':'bio',
            'project_interest':'project_interest',
            'disciplines':'talent_disciplines',
            'skills':'skills',
            'services':'talent_service_groups',
            'industries_worked':'industries_worked',
            'jobs':'jobs',
            'schools':'schools',
            'certifications':'certifications',
            'awards':'awards',
            'profile_links':'profile_links',
        }
        let selected = {};

        TB.map(selectedFields, ( checked, selectionType) => {
            if (checked === true && fields[selectionType]) {
                selected[fields[selectionType]] = resumeImportData[selectionType]
            }
            if (TB.isObject(checked)) {
                let selectedItems = []
                TB.map(checked, (subCheck, index) => {
                    if (subCheck === true) {
                        selectedItems.push(resumeImportData[selectionType][index]);
                    }
                })
                if (selectedItems?.length) {
                    if (auth[fields[selectionType]]?.length) {
                        selectedItems = [...auth[fields[selectionType]] || [], ...selectedItems]
                    }

                    selected[fields[selectionType]] = selectedItems
                }
            }
        })

        if (selected.jobs?.length) {
            selected.jobs = TB.map(selected.jobs, job => {
                job.is_still_there = job.is_still_there ? '1' : '0';
                return job
            })
        }

        if (selected.profile_links?.length) {
            selected.profile_links = TB.map(selected.profile_links, link => {
                if (TB.isString(link.type) && TB.find(LinkTypes, ['name', link.type])) {
                    return {
                        ...link,
                        ...TB.find(LinkTypes, ['name', link.type])
                    }
                }
                return link;
            })
            selected.profile_links = TB.filter(selected.profile_links, link => !TB.isNaN(link.type))
        }

        if (selected.talent_disciplines?.length) {
            selected.talent_disciplines = TB.map(selected.talent_disciplines, job => {
                if (!job.id && job.discipline_id) {
                    job.id = job.discipline_id;
                }
                return job
            })
        }

        return props.onSubmit(selected);
    }

    const CheckboxField = ({ checked, onChange, children, style = {} }) => (
        <div
            className="flex items-start gap-4 flex-row"
            style={{  ...style }}>
            <Space>
                <Checkbox
                    checked={checked}
                    onChange={onChange}
                />
            </Space>
            <div style={{ flex: 1 }}>{children}</div>
        </div>
    );

    const SectionTitle = ({ icon, title, items, section }) => {
        const isAllSelected = Array.isArray(section) ? (
            section.every(field => selectedFields[field])
        ) : (Array.isArray(items) && items.length > 0 &&
            items.every((_, index) => selectedFields[section]?.[index]));


        const handleToggleAll = (e) => {
            const newValue = e.target.checked;

            const updatedSection = {};
            if (!items && Array.isArray(section)) {
                let updatedSection = {};
                section.forEach(field => {
                    updatedSection[field] = newValue;
                });
                setSelectedFields(prev => ({
                    ...prev,
                    ...updatedSection
                }))
            }else if (Array.isArray(items) && items.length > 0) {

                items.forEach((_, index) => {
                    updatedSection[index] = newValue;
                });

                setSelectedFields(prev => ({
                    ...prev,
                    [section]: updatedSection
                }));
            }
        };

        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i className={icon} />
                    <span>{title}</span>
                </div>
                {(Array.isArray(section) || items?.length > 0) && (
                    <Space>
                        <Checkbox
                            checked={isAllSelected}
                            onChange={handleToggleAll}
                        >
                            <Text type="secondary" style={{ fontSize: '12px' }}>Import All</Text>

                        </Checkbox>
                    </Space>
                )}
            </div>
        );
    };

    const canImportInfoData = useCallback(
        () => {
            let hasValidItems = false;
            if (resumeImportData.years_of_experience && !TB.isNaN(parseInt(resumeImportData.years_of_experience)) && parseInt(resumeImportData.years_of_experience) < 100) {
                hasValidItems = true;
            }
            if (resumeImportData.linkedin_profile_url && TB.isValidUrl(resumeImportData.linkedin_profile_url)) {
                hasValidItems = true
            }
            if (resumeImportData.bio?.length || resumeImportData.project_interest?.length) {
                hasValidItems = true;
            }
            return hasValidItems
        },
        [resumeImportData],
    );


    const formatDate = (dateString) => {
        if (!dateString) return 'Present';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short'
        });
    };
    const shouldShowProfileInfo = !auth.isApplicationApproved();
    const shouldShowProfileItems = auth.isApplicationApproved();

    return (
        <React.Fragment>
            <div style={{maxWidth: '1200px', margin: '0 auto', padding: '24px'}}>
                <Space direction="vertical" size={32} className="text-left" style={{width: '100%'}}>

                    {shouldShowProfileInfo && (
                        <React.Fragment>
                            {/* Basic Info Card */}
                            {canImportInfoData() && (
                                <Card title={<SectionTitle icon="fas fa-user" title="Personal Information" section={[
                                    'years_of_experience',
                                    'linkedin_profile_url',
                                    'bio',
                                    'project_interest'
                                ]}/>}>
                                    <Space direction="vertical" size={16} style={{width: '100%'}}>

                                        {!!resumeImportData.years_of_experience && !TB.isNaN(parseInt(resumeImportData.years_of_experience)) && resumeImportData.years_of_experience < 100 && (
                                            <CheckboxField
                                                checked={selectedFields.years_of_experience}
                                                onChange={(e) => setSelectedFields(prev => ({
                                                    ...prev,
                                                    years_of_experience: e.target.checked
                                                }))}
                                            >
                                                <Space direction="vertical" size={0}>
                                                    <div>
                                                        <Text strong>Years of Experience: </Text>
                                                        <Text>{resumeImportData.years_of_experience}</Text>
                                                    </div>

                                                </Space>
                                            </CheckboxField>
                                        )}

                                        {resumeImportData.linkedin_profile_url?.length > 0 && TB.isValidUrl(resumeImportData.linkedin_profile_url) && (
                                            <CheckboxField
                                                checked={selectedFields.linkedin_profile_url}
                                                onChange={(e) => setSelectedFields(prev => ({
                                                    ...prev,
                                                    linkedin_profile_url: e.target.checked
                                                }))}
                                            >
                                                <Space direction="vertical" size={0}>
                                                    <div>
                                                        <Text strong>LinkedIn: </Text>
                                                        <a href={resumeImportData.linkedin_profile_url} target="_blank"
                                                           rel="noopener noreferrer">
                                                            {resumeImportData.linkedin_profile_url}
                                                        </a>
                                                    </div>

                                                </Space>
                                            </CheckboxField>
                                        )}

                                        {String(resumeImportData.bio)?.length > 0 && (
                                            <CheckboxField
                                                checked={selectedFields.bio}
                                                onChange={(e) => setSelectedFields(prev => ({
                                                    ...prev,
                                                    bio: e.target.checked
                                                }))}
                                            >
                                                <div>
                                                    <Text strong>Bio: </Text>
                                                    <Paragraph style={{margin: 0}}>{resumeImportData.bio}</Paragraph>
                                                </div>
                                            </CheckboxField>
                                        )}

                                        {!!resumeImportData.project_interest && (
                                            <CheckboxField
                                                checked={selectedFields.project_interest}
                                                onChange={(e) => setSelectedFields(prev => ({
                                                    ...prev,
                                                    project_interest: e.target.checked
                                                }))}
                                            >
                                                <div>
                                                    <Text strong>Project Interest: </Text>
                                                    <Paragraph
                                                        style={{margin: 0}}>{resumeImportData.project_interest}</Paragraph>
                                                </div>
                                            </CheckboxField>
                                        )}
                                    </Space>
                                </Card>
                            )}
                            {/* Roles (Disciplines) */}
                            {resumeImportData.disciplines && resumeImportData.disciplines.length > 0 && (
                                <Card title={<SectionTitle
                                    icon="fas fa-user-tie"
                                    title="Roles"
                                    items={resumeImportData.disciplines}
                                    section="disciplines"
                                />}>
                                    <Space direction="horizontal" size={8} className="flex-row flex-wrap gap-y-4">
                                        {resumeImportData.disciplines.map((discipline, index) => (
                                            <Tag color={selectedFields.disciplines?.[index] ? "purple" : "default"}
                                                 key={`discipline-${index}`}
                                                 className="clickable flex items-center flex-row h-7"
                                                 onClick={(e) => setSelectedFields(prev => ({
                                                     ...prev,
                                                     disciplines: {
                                                         ...(prev.disciplines || {}),
                                                         [index]: !selectedFields.disciplines?.[index]
                                                     }
                                                 }))}
                                            >
                                                <Space className="flex items-center flex-row h-5">
                                                    <Checkbox
                                                        className="mr-2 pointer-events-none"
                                                        checked={selectedFields.disciplines?.[index]}
                                                    />
                                                </Space>

                                                <span
                                                    className="flex items-center flex-row h-5">{discipline.name} ({laravel.talent_scoring_options[discipline.self_score]})
                                                </span>

                                            </Tag>

                                        ))}
                                    </Space>
                                </Card>
                            )}

                            {/* Skills & Industries */}
                            {resumeImportData.skills && resumeImportData.skills.length > 0 && (
                                <Card title={<SectionTitle
                                    icon="fas fa-trophy"
                                    title="Skills"
                                    items={resumeImportData.skills}
                                    section="skills"
                                />}>
                                    <Space direction="horizontal" size={8} className="flex-row flex-wrap gap-y-4">
                                        {resumeImportData.skills.map((skill, index) => (
                                            <Tag color={selectedFields.skills?.[index] ? "purple" : "default"}
                                                 key={index}
                                                 className="clickable flex items-center flex-row h-7"
                                                 onClick={(e) => setSelectedFields(prev => ({
                                                     ...prev,
                                                     skills: {
                                                         ...(prev.skills || {}),
                                                         [index]: !selectedFields.skills?.[index]
                                                     }
                                                 }))}
                                            >
                                                <Space className="flex items-center flex-row h-5">
                                                    <Checkbox
                                                        className="mr-2 pointer-events-none"
                                                        checked={selectedFields.skills?.[index]}
                                                    />
                                                </Space>

                                                <span
                                                    className="flex items-center flex-row h-5">{skill.name} ({laravel.talent_scoring_options[skill.self_score]})
                                                </span>

                                            </Tag>

                                        ))}
                                    </Space>
                                </Card>
                            )}

                            {resumeImportData.industries_worked && resumeImportData.industries_worked.length > 0 && (
                                <Card title={<SectionTitle
                                    icon="fas fa-building"
                                    title="Industries"
                                    items={resumeImportData.industries_worked}
                                    section="industries_worked"
                                />}>
                                    <Space direction="horizontal" size={8} className="flex-row flex-wrap gap-y-4">
                                        {resumeImportData.industries_worked.map((industry, index) => (
                                            <Tag
                                                color={selectedFields.industries_worked?.[index] ? "purple" : "default"}
                                                key={index}
                                                className="clickable flex items-center flex-row h-7"
                                                onClick={(e) => setSelectedFields(prev => ({
                                                    ...prev,
                                                    industries_worked: {
                                                        ...(prev.industries_worked || {}),
                                                        [index]: !selectedFields.industries_worked?.[index]
                                                    }
                                                }))}
                                            >
                                                <Space className="flex items-center flex-row h-5">
                                                    <Checkbox
                                                        className="mr-2 pointer-events-none"
                                                        checked={selectedFields.industries_worked?.[index]}
                                                    />
                                                </Space>

                                                <span
                                                    className="flex items-center flex-row h-5">{industry.name} ({laravel.talent_scoring_options[industry.self_score]})
                                                </span>

                                            </Tag>
                                        ))}
                                    </Space>
                                </Card>
                            )}


                            {/* Services */}
                            {resumeImportData.services && resumeImportData.services.length > 0 && (
                                <Card title={<SectionTitle
                                    icon="fas fa-cog"
                                    title="Services"
                                    items={resumeImportData.services}
                                    section="services"
                                />}>
                                    <Space direction="horizontal" size={8} className="flex-row flex-wrap gap-y-4">
                                        {resumeImportData.services.map((service, index) => (
                                            <Tag color={selectedFields.services?.[index] ? "purple" : "default"}
                                                 key={index}
                                                 className="clickable flex items-center flex-row h-7"
                                                 onClick={(e) => setSelectedFields(prev => ({
                                                     ...prev,
                                                     services: {
                                                         ...(prev.services || {}),
                                                         [index]: !selectedFields.services?.[index]
                                                     }
                                                 }))}
                                            >
                                                <Space className="flex items-center flex-row h-5">
                                                    <Checkbox
                                                        className="mr-2 pointer-events-none"
                                                        checked={selectedFields.services?.[index]}
                                                    />
                                                </Space>

                                                <span className="flex items-center flex-row h-5">{service?.name}</span>

                                            </Tag>
                                        ))}
                                    </Space>
                                </Card>
                            )}
                        </React.Fragment>
                    )}
                    {shouldShowProfileItems && (
                        <React.Fragment>

                            {/* Experience Card */}
                            {resumeImportData.jobs && resumeImportData.jobs.length > 0 && (
                                <Card title={<SectionTitle
                                    icon="fas fa-briefcase"
                                    title="Work Experience"
                                    items={resumeImportData.jobs}
                                    section="jobs"
                                />}>
                                    <Space direction="vertical" size={24} style={{width: '100%'}}>
                                        {resumeImportData.jobs.map((job, index) => (
                                            <CheckboxField
                                                key={`job-${index}`}
                                                checked={selectedFields.jobs?.[index]}
                                                onChange={(e) => setSelectedFields(prev => ({
                                                    ...prev,
                                                    jobs: {
                                                        ...(prev.jobs || {}),
                                                        [index]: e.target.checked
                                                    }
                                                }))}
                                            >
                                                <div className="flex flex-row items-start gap-3 mb-2">
                                                    <div className="flex flex-row justify-start">
                                                        <div>
                                                            <Text strong>Role: </Text>
                                                            <Text>{job.role || 'N/A'}</Text>
                                                            <br/>
                                                            <Text strong>Company: </Text>
                                                            <Text>{job.employer || 'N/A'}</Text>
                                                            {(job.started_at || job.ended_at) && (
                                                                <>
                                                                    <br/>
                                                                    <Text type="secondary"
                                                                          className="whitespace-no-wrap text-xs my-1.5">
                                                                        {formatDate(job.started_at)} - {formatDate(job.ended_at)}
                                                                    </Text>
                                                                </>
                                                            )}
                                                            <br/>
                                                            <Text strong>Description: </Text>
                                                            <Paragraph
                                                                style={{margin: 0}}>{job.description || 'N/A'}</Paragraph>

                                                        </div>

                                                    </div>

                                                    {job.image_path && (
                                                        <img className="w-full h-auto max-w-20 ml-auto"
                                                             src={job.image_path}/>
                                                    )}
                                                </div>
                                            </CheckboxField>
                                        ))}
                                    </Space>
                                </Card>
                            )}

                            {/* Education */}
                            {resumeImportData.schools && resumeImportData.schools.length > 0 && (
                                <Card title={<SectionTitle
                                    icon="fas fa-graduation-cap"
                                    title="Education"
                                    items={resumeImportData.schools}
                                    section="schools"
                                />}>
                                    <Space direction="vertical" size={24} style={{width: '100%'}}>
                                        {resumeImportData.schools.map((edu, index) => (
                                            <CheckboxField
                                                key={`schools-${index}`}
                                                checked={selectedFields.schools?.[index]}
                                                onChange={(e) => setSelectedFields(prev => ({
                                                    ...prev,
                                                    schools: {
                                                        ...(prev.schools || {}),
                                                        [index]: e.target.checked
                                                    }
                                                }))}
                                            >
                                                <div className="flex flex-row items-start gap-3 mb-2">
                                                    <div className="flex flex-row justify-start">
                                                        <div>
                                                            <Text strong>School: </Text>
                                                            <Text>{edu.name}</Text>
                                                            {edu.degree && (
                                                                <>
                                                                    <br/>
                                                                    <Text strong>Degree: </Text>
                                                                    <Text>{edu.earned_degree}</Text>
                                                                </>
                                                            )}
                                                            {edu.field_of_study && (
                                                                <>
                                                                    <br/>
                                                                    <Text strong>Field: </Text>
                                                                    <Text>{edu.field_of_study}</Text>
                                                                </>
                                                            )}
                                                            {(edu.started_at || edu.ended_at) && (
                                                                <>
                                                                    <br/>
                                                                    <Text type="secondary"
                                                                          className="whitespace-no-wrap text-xs">
                                                                        {formatDate(edu.started_at)} - {formatDate(edu.ended_at)}
                                                                    </Text>
                                                                </>
                                                            )}
                                                        </div>

                                                    </div>

                                                    {edu.image_path && (
                                                        <img className="w-full h-auto max-w-20 ml-auto"
                                                             src={edu.image_path}/>
                                                    )}
                                                </div>
                                            </CheckboxField>
                                        ))}
                                    </Space>
                                </Card>
                            )}

                            {/* Certifications */}
                            {resumeImportData.certifications && resumeImportData.certifications.length > 0 && (
                                <Card title={<SectionTitle
                                    icon="fas fa-award"
                                    title="Certifications"
                                    items={resumeImportData.certifications}
                                    section="certifications"
                                />}>
                                    <Space direction="vertical" size={24} style={{width: '100%'}}>
                                        {resumeImportData.certifications.map((cert, index) => (
                                            <CheckboxField
                                                key={`cert-${index}`}
                                                checked={selectedFields.certifications?.[index]}
                                                onChange={(e) => setSelectedFields(prev => ({
                                                    ...prev,
                                                    certifications: {
                                                        ...(prev.certifications || {}),
                                                        [index]: e.target.checked
                                                    }
                                                }))}
                                            >

                                                <div className="flex flex-row items-start gap-3 mb-2">
                                                    <div>
                                                        <Text strong>Name: </Text>
                                                        <Text>{cert.name}</Text>
                                                        {cert.earned_at && (
                                                            <>
                                                                <br/>
                                                                <Text strong>Earned: </Text>
                                                                <Text>{formatDate(cert.earned_at)}</Text>
                                                            </>
                                                        )}
                                                        <br/>
                                                        <Text strong>Description: </Text>
                                                        <Paragraph
                                                            style={{margin: 0}}>{cert.description || 'N/A'}</Paragraph>
                                                    </div>

                                                    {cert.image_path && (
                                                        <img className="w-full h-auto max-w-20 ml-auto"
                                                             src={cert.image_path}/>
                                                    )}
                                                </div>
                                            </CheckboxField>
                                        ))}
                                    </Space>
                                </Card>
                            )}

                            {/* Awards */}
                            {resumeImportData.awards && resumeImportData.awards.length > 0 && (
                                <Card title={<SectionTitle
                                    icon="fas fa-trophy"
                                    title="Awards"
                                    items={resumeImportData.awards}
                                    section="awards"
                                />}>
                                    <Space direction="vertical" size={24} style={{width: '100%'}}>
                                        {resumeImportData.awards.map((award, index) => (
                                            <CheckboxField
                                                key={`award-${index}`}
                                                checked={selectedFields.awards?.[index]}
                                                onChange={(e) => setSelectedFields(prev => ({
                                                    ...prev,
                                                    awards: {
                                                        ...(prev.awards || {}),
                                                        [index]: e.target.checked
                                                    }
                                                }))}
                                            >
                                                <div className="flex flex-row items-start gap-3 mb-2">
                                                    <div>
                                                        <Text strong>Name: </Text>
                                                        <Text>{award.name}</Text>
                                                        {award.year && (
                                                            <>
                                                                <br/>
                                                                <Text strong>Year: </Text>
                                                                <Text>{award.year}</Text>
                                                            </>
                                                        )}

                                                        {award.url && (
                                                            <>
                                                                <br/>
                                                                <Text strong>URL: </Text>
                                                                <Text style={{margin: 0}}>{award.url}</Text>
                                                            </>
                                                        )}

                                                        <br/>
                                                        <Text strong>Description: </Text>
                                                        <Paragraph
                                                            style={{margin: 0}}>{award.description || 'N/A'}</Paragraph>
                                                    </div>

                                                    {award.image_path && (
                                                        <img className="w-full h-auto max-w-20 ml-auto"
                                                             src={award.image_path}/>
                                                    )}
                                                </div>
                                            </CheckboxField>
                                        ))}
                                    </Space>
                                </Card>
                            )}

                            {/* Profile Links */}
                            {/*{resumeImportData.profile_links && resumeImportData.profile_links.length > 0 && (*/}
                            {/*    <Card title={<SectionTitle*/}
                            {/*        icon="fas fa-link"*/}
                            {/*        title="Profile Links"*/}
                            {/*        items={resumeImportData.profile_links}*/}
                            {/*        section="profile_links"*/}
                            {/*    />}>*/}
                            {/*        <Space direction="vertical" size={8}>*/}
                            {/*            {resumeImportData.profile_links.map((link, index) => (*/}
                            {/*                <CheckboxField*/}
                            {/*                    key={index}*/}
                            {/*                    checked={selectedFields.profile_links?.[index]}*/}
                            {/*                    onChange={(e) => setSelectedFields(prev => ({*/}
                            {/*                        ...prev,*/}
                            {/*                        profile_links: {*/}
                            {/*                            ...(prev.profile_links || {}),*/}
                            {/*                            [index]: e.target.checked*/}
                            {/*                        }*/}
                            {/*                    }))}*/}
                            {/*                >*/}
                            {/*                    <div>*/}
                            {/*                        <Text strong>{link.type}: </Text>*/}
                            {/*                        <a href={link.url} target="_blank" rel="noopener noreferrer">*/}
                            {/*                            {link.url}*/}
                            {/*                        </a>*/}
                            {/*                    </div>*/}
                            {/*                </CheckboxField>*/}
                            {/*            ))}*/}
                            {/*        </Space>*/}
                            {/*    </Card>*/}
                            {/*)}*/}
                        </React.Fragment>
                    )}


                </Space>
            </div>
            <div className="flex flex-row items-center gap-3 mx-auto justify-center mt-4">

                {props.children}
                <button onClick={persistSelection}
                        disabled={props.isDisabled}
                        className="btn btn-primary md:w-3/12">
                    Import Resume Data
                </button>
            </div>
        </React.Fragment>
    );
};

export default ResumeImportSelection;